import { useEffect, useState } from 'react';

interface Quote {
  readonly text: string;
  readonly author: string;
}

const QUOTES: ReadonlyArray<Quote> = [
  {
    text: "Une bibliothèque, c'est un lieu où l'on entre pour chercher un livre, et d'où l'on ressort avec dix autres.",
    author: 'Anonyme',
  },
  {
    text: "Lire, c'est s'évader, et c'est ce qu'il y a de plus sain.",
    author: 'François Mauriac',
  },
  {
    text: "Un livre est une fenêtre par laquelle on s'évade.",
    author: 'Julien Green',
  },
  {
    text: "Les livres sont des miroirs : on n'y voit que ce qu'on a déjà en soi.",
    author: 'Carlos Ruiz Zafón',
  },
  {
    text: "Il n'y a pas de meilleur ami pour l'homme qu'un livre.",
    author: 'Ernest Hemingway',
  },
  {
    text: "Lire, c'est boire et manger. L'esprit qui ne lit pas maigrit comme le corps qui ne mange pas.",
    author: 'Victor Hugo',
  },
  {
    text: 'Un livre est un rêve que vous tenez dans vos mains.',
    author: 'Neil Gaiman',
  },
  {
    text: "On reconnaît le bonheur au bruit qu'il fait quand il s'en va.",
    author: 'Jacques Prévert',
  },
  {
    text: "Le livre est l'œuvre du temps, comme un grand fleuve qui dépose sur ses rives les alluvions du savoir.",
    author: 'Anatole France',
  },
  {
    text: "Lire un livre, c'est faire un voyage ; faire un voyage, c'est lire un livre.",
    author: 'Victor Hugo',
  },
  {
    text: "Quand je pense à tous les livres qu'il me reste à lire, j'ai la certitude d'être encore heureux.",
    author: 'Jules Renard',
  },
  {
    text: 'Une chambre sans livres est comme un corps sans âme.',
    author: 'Cicéron',
  },
  {
    text: "Les livres sont les abeilles qui portent la semence d'une intelligence à l'autre.",
    author: 'James Russell Lowell',
  },
  {
    text: "Il n'y a aucun mal qu'un bon livre ne puisse soulager.",
    author: 'Anonyme',
  },
  {
    text: "Lire, c'est rêver les yeux ouverts.",
    author: 'Stephen King',
  },
  {
    text: 'Un bon livre est un événement dans ma vie.',
    author: 'Stendhal',
  },
  {
    text: "Le monde appartient à ceux qui lisent.",
    author: 'Anonyme',
  },
  {
    text: "Les livres sont des amis froids et sûrs.",
    author: 'Victor Hugo',
  },
  {
    text: "Le livre est un véritable instrument de liberté.",
    author: 'Jules Ferry',
  },
  {
    text: "Aimer lire, c'est faire de l'ennui une heure de délice.",
    author: 'Montesquieu',
  },
  {
    text: "Quand on lit un livre, on voyage sans bouger.",
    author: 'Anonyme',
  },
  {
    text: "Les bons livres font les bons amis.",
    author: 'Anonyme',
  },
  {
    text: "Lire, c'est vivre deux fois.",
    author: 'Roger Judrin',
  },
  {
    text: "Le plus grand voyage commence à la première page.",
    author: 'Anonyme',
  },
  {
    text: "Un livre ouvre un monde, un livre ferme un monde.",
    author: 'Anonyme',
  },
  {
    text: "Les livres ne se lisent pas : ils se relisent.",
    author: 'Vladimir Nabokov',
  },
  {
    text: "Le livre est le compagnon le plus fidèle dans les heures de solitude.",
    author: 'Anonyme',
  },
  {
    text: "Une heure de lecture est le souverain remède contre les dégoûts de la vie.",
    author: 'Montesquieu',
  },
  {
    text: "Les vrais lecteurs ne ferment jamais vraiment un livre.",
    author: 'Anonyme',
  },
  {
    text: "Un livre est une bouteille jetée en pleine mer sur laquelle il faut coller cette étiquette : attrape qui peut.",
    author: 'Alfred de Musset',
  },
  {
    text: "Les livres sont des sphinx qui font naître les questions au lieu d'apporter les réponses.",
    author: 'Anonyme',
  },
  {
    text: "Les livres sont les abeilles qui transportent la poussière fécondante d'un esprit à l'autre.",
    author: 'James Russell Lowell',
  },
  {
    text: "C'est dans les livres qu'on apprend à vivre, et c'est aussi dans les livres qu'on apprend à mourir.",
    author: 'Anonyme',
  },
  {
    text: "Lire est à l'esprit ce que la gymnastique est au corps.",
    author: 'Joseph Addison',
  },
  {
    text: "Un livre, c'est un instrument de pensée mais c'est aussi un objet de rêve.",
    author: 'Daniel Pennac',
  },
  {
    text: "Le verbe lire ne supporte pas l'impératif.",
    author: 'Daniel Pennac',
  },
  {
    text: "Donnez à votre enfant un livre, vous lui donnez une fenêtre sur le monde.",
    author: 'Anonyme',
  },
  {
    text: "On n'est jamais seul avec un livre à portée de main.",
    author: 'Anonyme',
  },
  {
    text: "Le livre est une porte ouverte sur l'imaginaire.",
    author: 'Anonyme',
  },
  {
    text: "Tu ne peux ouvrir un livre sans en tirer une leçon.",
    author: 'Confucius',
  },
  {
    text: "Les grands livres ne nous trompent jamais.",
    author: 'Hermann Hesse',
  },
  {
    text: "Lire, c'est apprendre à se taire.",
    author: 'Christian Bobin',
  },
  {
    text: "Lire un livre est un acte de résistance.",
    author: 'Anonyme',
  },
  {
    text: "Un bon livre est celui qui nous lit autant que nous le lisons.",
    author: 'Anonyme',
  },
  {
    text: "Les livres ont les mêmes ennemis que l'homme : le feu, l'humidité, les bêtes, le temps, et leur propre contenu.",
    author: 'Paul Valéry',
  },
  {
    text: "Choisis un auteur comme tu choisis un ami.",
    author: 'Wentworth Dillon',
  },
  {
    text: "Le livre est le meilleur des compagnons silencieux.",
    author: 'Anonyme',
  },
  {
    text: "Toute lecture est une rencontre.",
    author: 'Anonyme',
  },
  {
    text: "Lis pour vivre.",
    author: 'Gustave Flaubert',
  },
  {
    text: "Les seuls beaux yeux sont ceux qui vous regardent avec tendresse... et ceux qui lisent.",
    author: 'Anonyme',
  },
  {
    text: "Il faut lire les livres comme on prend les remèdes : à dose savante.",
    author: 'Anonyme',
  },
  {
    text: "Un livre que l'on ferme est un ami qui s'en va.",
    author: 'Anonyme',
  },
  {
    text: "Toute lecture est un acte de création.",
    author: 'Ralph Waldo Emerson',
  },
  {
    text: "Lire, c'est dialoguer.",
    author: 'Jorge Luis Borges',
  },
  {
    text: "Je n'imagine pas le paradis autrement que sous la forme d'une bibliothèque.",
    author: 'Jorge Luis Borges',
  },
  {
    text: "L'odeur d'un vieux livre est l'arôme du temps qui passe.",
    author: 'Anonyme',
  },
  {
    text: "Les livres sont des frêles esquifs sur l'océan du temps.",
    author: 'Francis Bacon',
  },
  {
    text: "Une bibliothèque est une assemblée d'âmes immortelles.",
    author: 'Francis Bacon',
  },
  {
    text: "Lire un livre, c'est avoir une conversation avec son auteur.",
    author: 'René Descartes',
  },
  {
    text: "Un livre doit être la hache qui brise la mer gelée en nous.",
    author: 'Franz Kafka',
  },
  {
    text: "Lire est le seul moyen de s'enrichir sans voler personne.",
    author: 'Anonyme',
  },
  {
    text: "Un livre est un miracle silencieux.",
    author: 'Anonyme',
  },
  {
    text: "Le livre est un ami qui ne change jamais.",
    author: 'Christine de Pizan',
  },
  {
    text: "Lire, c'est se promener dans un monde fait main.",
    author: 'Anonyme',
  },
  {
    text: "Le livre est notre meilleur antidépresseur, sans effet secondaire.",
    author: 'Anonyme',
  },
  {
    text: "Le livre est la mémoire de l'humanité.",
    author: 'Paul Otlet',
  },
  {
    text: "On ne lit pas un livre, on lit avec un livre.",
    author: 'Anonyme',
  },
  {
    text: "Les livres sont les plus calmes et constants des amis ; les plus accessibles et les plus sages des conseillers ; et les plus patients des professeurs.",
    author: 'Charles W. Eliot',
  },
  {
    text: "Tant qu'on n'a pas lu un livre, on ne sait pas ce qu'il contient ; quand on l'a lu, on sait ce qu'on en pense.",
    author: 'Anonyme',
  },
  {
    text: "Le bonheur, c'est de continuer à désirer ce que l'on possède : un livre, par exemple.",
    author: 'Anonyme',
  },
  {
    text: "Les livres sont des avions, des trains et des routes : ils sont la destination et le voyage.",
    author: 'Anna Quindlen',
  },
  {
    text: "Un livre, c'est de l'encre et du papier, mais aussi un peu de l'âme de celui qui l'a écrit.",
    author: 'Anonyme',
  },
  {
    text: "Plus on lit, plus on est libre.",
    author: 'Anonyme',
  },
  {
    text: "Lire, c'est dérober à autrui ses pensées pour en nourrir les siennes.",
    author: 'Voltaire',
  },
  {
    text: "Un livre ne fait jamais de bruit ; il chuchote à l'oreille du cœur.",
    author: 'Anonyme',
  },
  {
    text: "Les livres laissent dans la mémoire des traces ineffaçables.",
    author: 'Henri Bosco',
  },
  {
    text: "Le livre est une lampe qui éclaire l'esprit.",
    author: 'Anonyme',
  },
  {
    text: "Un bon livre vaut un voyage.",
    author: 'Anonyme',
  },
  {
    text: "Le livre est le souvenir du papier devenu pensée.",
    author: 'Anonyme',
  },
  {
    text: "On vit aussi longtemps qu'on lit.",
    author: 'Anonyme',
  },
  {
    text: "Lire, c'est emprunter ; en tirer profit, c'est payer ses dettes.",
    author: 'Georg Christoph Lichtenberg',
  },
  {
    text: "On n'a jamais fini un livre. On le quitte, c'est tout.",
    author: 'Anonyme',
  },
  {
    text: "Un livre est un cadeau qu'on peut ouvrir encore et encore.",
    author: 'Garrison Keillor',
  },
  {
    text: "Lire est la nourriture de l'âme.",
    author: 'Anonyme',
  },
  {
    text: "Quand le thé fume et que les pages tournent, le monde peut bien attendre.",
    author: 'Anonyme',
  },
  {
    text: "Une tasse de thé, un fauteuil, un livre : trois fois rien et tout à la fois.",
    author: 'Anonyme',
  },
  {
    text: "Les livres nous font traverser le temps comme la pluie traverse l'automne.",
    author: 'Anonyme',
  },
  {
    text: "Une bibliothèque, c'est une cathédrale d'histoires.",
    author: 'Anonyme',
  },
  {
    text: "Chaque livre lu est une vie de plus.",
    author: 'Anonyme',
  },
  {
    text: "Garde toujours un livre près de toi ; il te tiendra chaud quand le monde sera froid.",
    author: 'Anonyme',
  },
];

const ROTATION_MS = 60 * 60 * 1000;
const FADE_MS = 600;

function initialIndex(): number {
  return Math.floor((Date.now() / ROTATION_MS) % QUOTES.length);
}

export function QuoteCard(): JSX.Element {
  const [index, setIndex] = useState<number>(initialIndex);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const tick = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex((i) => (i + 1) % QUOTES.length);
        setVisible(true);
      }, FADE_MS);
    }, ROTATION_MS);
    return () => window.clearInterval(tick);
  }, []);

  const quote = QUOTES[index] ?? QUOTES[0]!;

  return (
    <section className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-sage-light to-cream-light p-6 shadow-md md:p-7">
      <span
        className="pointer-events-none absolute -top-8 left-2 select-none font-serif text-[140px] leading-none text-sage-dark opacity-20"
        aria-hidden
      >
        "
      </span>
      <div
        className="quote-fade"
        style={{
          opacity: visible ? 1 : 0,
          transition: `opacity ${FADE_MS}ms ease-in-out`,
        }}
      >
        <p className="relative font-serif text-base italic leading-relaxed text-brown md:text-lg">
          {quote.text}
        </p>
        <p className="mt-3 text-right font-script text-lg text-sage-dark">
          — {quote.author}
        </p>
      </div>
    </section>
  );
}
